import { Field, Menu, MenuContent, MenuTrigger } from '@optiaxiom/react';

import type { SpecializedAgent } from '@frontend/types/specialized-agent';

const INFERENCE_TYPES = [
  {
    value: 'rudimentary',
    label: 'Quick',
    description: 'Fast, basic responses for simple questions or tasks.',
  },
  {
    value: 'simple',
    label: 'Standard',
    description: 'Reliable answers for most everyday needs.',
  },
  {
    value: 'simple_with_thinking',
    label: 'Balanced',
    description: 'Like Standard, but with extra reasoning.',
  },
  {
    value: 'complex',
    label: 'Complex',
    description: 'Advanced reasoning and detail for complex tasks.',
  },
  {
    value: 'complex_with_thinking',
    label: 'Pro',
    description: 'Maximum reasoning depth for the toughest or most nuanced challenges.',
  },
  { value: 'code', label: 'Code', description: 'Writes, explains, and debugs code.' },
];

type InferenceTypeSelectorProps = {
  value: SpecializedAgent['inference_type'];
  onChange: (value: SpecializedAgent['inference_type']) => void;
};

export function InferenceTypeSelector({ value, onChange }: InferenceTypeSelectorProps) {
  return (
    <Field
      label="Inference Level"
      info="Controls how much reasoning Opal applies when generating its response. Higher inference levels can take more time, but apply deeper reasoning to output"
    >
      <Menu
        options={INFERENCE_TYPES.map(option => ({
          label: option.label,
          description: option.description,
          execute: () => onChange(option.value as SpecializedAgent['inference_type']),
          selected: option.value === value,
        }))}
      >
        <MenuTrigger w="224">
          {INFERENCE_TYPES.find(opt => opt.value === value)?.label || 'Standard'}
        </MenuTrigger>
        <MenuContent />
      </Menu>
    </Field>
  );
}
